import { Action } from '@ngrx/store';
import { SalesDocumentTypeIdType } from '../../../../shared/constants/sales-document-type-id';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { ProductOP, ProductsResponseOP } from '@cemex-core/cmx-api';

export enum ProductsActionTypes {
  LOAD = '[Products] Load products',
  LOAD_ULINK = '[Products] Load OP products',
  LOAD_COMPLETE = '[Products] Load products complete',
  LOAD_ULINK_COMPLETE = '[Products] Load IVM API products complete',
  ADD_PRODUCTS = '[Products] Add products',
  ADD_PRODUCTS_ULINK = '[Products] Add IVM API products',
  RESET = '[Products] Reset',
}

/**
 * Starts a load of the product-list from the application's store.
 */
export class ProductsLoadAction implements Action {
  readonly type = ProductsActionTypes.LOAD;

  constructor(public payload: SalesDocumentTypeIdType[]) { }
}
/**
 * Starts a load of the product-list from IVM API.
 */
export class ProductsULinkLoadAction implements Action {
  readonly type = ProductsActionTypes.LOAD_ULINK;

  constructor(public payload: SalesDocumentTypeIdType[]) { }
}

/**
 * Signals the end of loading a product-list from the store.
 * The handler in the reducer uses filterUniqueProducts, so duplicates should be removed by that.
 */
export class ProductsLoadCompleteAction implements Action {
  readonly type = ProductsActionTypes.LOAD_COMPLETE;

  constructor(public payload: IProduct[]) { }
}

/**
 * Signals the end of loading a product-list from the store for the IVM version of product API.
 * The handler in the reducer uses filterUniqueProducts, so duplicates should be removed by that.
 */
export class ProductsULinkLoadCompleteAction implements Action {
  readonly type = ProductsActionTypes.LOAD_ULINK_COMPLETE;

  constructor(public payload: ProductsResponseOP) { }
}

/**
 * Adds more products to the list in the store
 */
export class ProductsAddAction implements Action {
  readonly type = ProductsActionTypes.ADD_PRODUCTS;

  constructor(public payload: IProduct[]) { }
}

/**
 * Adds more products to the OpenPlatform list in the store (top products)
 */
export class ProductsAddULinkAction implements Action {
  readonly type = ProductsActionTypes.ADD_PRODUCTS_ULINK;

  constructor(public payload: ProductOP[]) { }
}


/**
 * Wipes clean the product-list.
 */
export class ProductsResetAction implements Action {
  readonly type = ProductsActionTypes.RESET;

  constructor() { }
}

export type ProductsActions =
  ProductsLoadAction |
  ProductsULinkLoadAction |
  ProductsLoadCompleteAction |
  ProductsULinkLoadCompleteAction |
  ProductsAddAction |
  ProductsAddULinkAction |
  ProductsResetAction;
